import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SuccessPage = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Traitement...");
  const [orderToken, setOrderToken] = useState(null); // Store the order token
  const API_URL = process.env.REACT_APP_API_URL;


  useEffect(() => {
    createOrder(); // Call createOrder when the component mounts
  }, []); // Empty dependency array ensures this runs only once

  const createOrder = async () => {
    try {
      setMessage("Création de la commande...");

      const storedCart = localStorage.getItem("cart");
      const cartItems = storedCart ? JSON.parse(storedCart) : [];

      if (cartItems.length === 0) {
        setMessage("Le panier est vide. Impossible de créer la commande.");
        console.warn("Cart is empty when creating order!");
        return;
      }

      const totalPrice = cartItems.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      );

      const response = await axios.post(
        `${API_URL}/api/create-order`,
        { cartItems: cartItems, totalPrice: totalPrice }
      );

      if (response.status === 201) {
        console.log("Order created:", response.data);
        setMessage("Commande créée avec succès. Redirection...");
        localStorage.removeItem("cart");

        setOrderToken(response.data.orderId); // Store the order token
        setTimeout(() => {
          navigate(`/tokenDetails/${response.data.orderId}`); // Navigate to token detail page
        }, 3000);
      } else {
        setMessage(
          `Erreur lors de la création de la commande. Code d'état : ${response.status}`
        );
      }
    } catch (error) {
      console.error(
        "Error creating order:",
        error.response?.data || error.message
      );
      setMessage(
        "Erreur lors de la création de la commande : " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="main-container">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="header-logo">Lememeprix</div>
            <div className="header-actions">
              <div className="address-input">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <img
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                alt="Profile"
                className="profile-image"
              />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <section className="success-banner">
          <div className="container">
            <i className="fa-solid fa-circle-check success-icon"></i>
            <h1 className="success-title">Traitement de la commande.....</h1>
            {/* <div className="order-info">
                            <span className="order-number">Order #{orderToken || "2025001"}</span>
                            <button className="copy-button">
                                <i className="fa-regular fa-copy"></i>
                            </button>
                        </div> */}
          </div>
          {/* Confetti Animation Elements */}
          <div className="confetti-animation">
            <div className="confetti-1"></div>
            <div className="confetti-2"></div>
            <div className="confetti-3"></div>
          </div>
        </section>

        {/* Order Success Card */}
        <section className="order-success">
          <div className="container">
            <div className="success-card">
              {/* Timeline */}
              <div className="order-timeline">
                <div className="timeline-steps">
                  <div className="timeline-step">
                    <div className="step-icon">
                      <i className="fa-solid fa-check"></i>
                    </div>
                    <p className="step-label">Traitement</p>
                  </div>
                  <div className="timeline-step">
                    <div className="step-icon">
                      <i className="fa-solid fa-box"></i>
                    </div>
                    <p className="step-label">Prêt à être récupéré</p>
                  </div>
                </div>
              </div>

              {/* Order Summary */}
              <div className="order-summary">
                <div className="pickup-time">
                  <p className="pickup-label">Heure de ramassage estimée</p>
                  <p className="pickup-value">Aujourd'hui, 14 h 30 - 14 h 45</p>
                  <i className="fa-regular fa-clock clock-icon"></i>
                </div>

                <div className="summary-details">
                  <h3 className="summary-title">Résumé de la commande</h3>
                  <div className="summary-items">
                    <div className="summary-item">
                      <span>2x Croissant Classic</span>
                      <span>6,00 €</span>
                    </div>
                    <div className="summary-item">
                      <span>3x Pain au Chocolat</span>
                      <span>9,00 €</span>
                    </div>
                  </div>
                  <div className="summary-total">
                    <span>Total</span>
                    <span>15,00 €</span>
                  </div>
                </div>

                <div className="action-buttons">
                  <button
                    className="view-details-button"
                    onClick={() => navigate(`/tokenDetails/${orderToken}`)}
                  >
                    Voir les détails de la commande
                  </button>
                  <button
                    className="back-to-home-button"
                    onClick={() => navigate("/")}
                  >
                    Retour à l'accueil
                  </button>
                </div>
                <p className="status-message">{message}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4 className="footer-title">Liens rapides</h4>
              <ul className="footer-links">
                <li>
                  <span className="footer-link">À propos de nous</span>
                </li>
                <li>
                  <span className="footer-link">Contact</span>
                </li>
                <li>
                  <span className="footer-link">Politique de confidentialité</span>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Suivez-nous</h4>
              <div className="social-icons">
                <span className="social-icon">
                  <i className="fa-brands fa-facebook"></i>
                </span>
                <span className="social-icon">
                  <i className="fa-brands fa-instagram"></i>
                </span>
                <span className="social-icon">
                  <i className="fa-brands fa-twitter"></i>
                </span>
              </div>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Assistance</h4>
              <p className="contact-info">Email: support@lememeprix.com</p>
              <p className="contact-info">Phone: +33 1 23 45 67 89</p>
            </div>
          </div>
          <div className="footer-copyright">
            © 2025 Lememeprix. Tous droits réservés.
          </div>
        </div>
      </footer>

      <style jsx>{`
        /* Main container */
        .main-container {
          min-height: 100vh;
          background-color: #fff;
          display: flex;
          flex-direction: column;
        }

        /* Header */
        .header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background-color: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          z-index: 50;
        }

        .header .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
        }

        .header-logo {
          font-size: 1.5rem;
          font-weight: bold;
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        /* CSS to center the text input */
        .address-input {
          position: relative;
          flex: 1; /* Let it occupy the available space */
          display: flex;
          align-items: center;
        }

        .address-input input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #e5e7eb;
          border-radius: 0.5rem;
          outline: none;
          padding-left: 2.5rem;
        }

        .address-input i {
          position: absolute;
          left: 1rem;
          color: #6b7280;
        }

        .header-actions img {
          border-radius: 50%; /* Make profile image round */
          width: 3rem;
          height: 3rem;
          object-fit: cover; /* Ensure image covers the area */
        }
        /* Main Content */
        .main-content {
          padding-top: 5rem;
        }

        /* Success Banner */
        .success-banner {
          background-color: #ef4444;
          color: #fff;
          padding: 4rem 0;
          position: relative;
          overflow: hidden; /* To contain confetti */
        }

        .success-banner .container {
          text-align: center;
          position: relative; /* Ensure content is above confetti */
          z-index: 10;
        }

        .success-icon {
          font-size: 4rem;
          margin-bottom: 1rem;
        }

        .success-title {
          font-size: 2.25rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .order-info {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
        }

        .order-number {
          font-size: 1.25rem;
        }

        .copy-button {
          background: none;
          border: none;
          color: #fff;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .copy-button:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }

        /* Confetti animation */
        .confetti-animation {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }

        .confetti-1 {
          animation: confetti-anim 10s -0.5s linear infinite both;
        }

        .confetti-2 {
          animation: confetti-anim 10s -2.5s linear infinite both;
        }

        .confetti-3 {
          animation: confetti-anim 10s -4.5s linear infinite both;
        }

        @keyframes confetti-anim {
          0% {
            transform: translateY(0) translateX(0) rotate(0);
            opacity: 1;
          }
          100% {
            transform: translateY(300px) translateX(200px) rotate(360deg);
            opacity: 0;
          }
        }

        /* Order Success Card */
        .order-success {
          margin-top: -5rem;
          position: relative;
          z-index: 10;
        }

        .success-card {
          background-color: #fff;
          border-radius: 0.75rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);
          padding: 2rem;
          max-width: 48rem;
          margin: 0 auto;
        }

        /* Order Timeline */
        .order-timeline {
          margin-bottom: 2rem;
        }

        .timeline-steps {
          display: flex;
          justify-content: space-between;
          position: relative;
        }

        .timeline-steps::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 0.125rem;
          background-color: #ef4444;
          transform: translateY(-50%);
        }

        .timeline-step {
          text-align: center;
          position: relative;
        }

        .step-icon {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 9999px;
          background-color: #ef4444;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          z-index: 1;
        }

        .step-label {
          margin-top: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
        }

        /* Order Summary */
        .summary-details {
          margin-bottom: 1.5rem;
        }

        .pickup-time {
          background-color: #f9fafb;
          padding: 1rem;
          border-radius: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .pickup-label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #4b5563;
        }

        .pickup-value {
          font-weight: bold;
        }
        .clock-icon {
          font-size: 1.25rem;
          color: #9ca3af;
        }

        .summary-details {
          margin-bottom: 1.5rem;
        }

        .summary-items {
        }

        .summary-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.5rem;
        }

        .summary-total {
          padding-top: 1rem;
          border-top: 2px solid #e5e7eb;
          font-weight: bold;
          font-size: 1.125rem;
        }

        .action-buttons {
          display: flex;
          gap: 1rem;
        }

        .view-details-button,
        .back-to-home-button {
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          color: #fff;
          background-color: #ef4444;
          transition: background-color 0.2s ease;
          border: none;
          cursor: pointer;
          text-decoration: none;
          text-align: center;
          flex: 1;
        }

        .back-to-home-button {
          background-color: #e5e7eb;
          color: #374151;
        }

        /* Footer */
        .footer {
          background-color: #f9fafb;
          padding: 3rem 0;
          margin-top: 4rem;
        }

        .footer .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 2rem;
        }

        @media (min-width: 768px) {
          .footer-content {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .footer-section {
          display: flex;
          flex-direction: column;
        }

        .footer-title {
          font-size: 1.25rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: 0.5rem;
        }

        .footer-link {
          color: #4b5563;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .footer-link:hover {
          color: #6b7280;
        }

        .social-icons {
          display: flex;
          gap: 1rem;
        }

        .social-icons i {
          font-size: 1.5rem;
          color: #4b5563;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .social-icons i:hover {
          color: #6b7280;
        }

        .contact-info {
          display: flex;
          flex-direction: column;
        }

        .contact-details {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.5rem;
          color: #4b5563;
        }
        @media (max-width: 767px) {
          /* Reduce font size for very small screens */
          .success-title {
            font-size: 2rem;
          }
          .order-info span {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default SuccessPage;